import { I_FlightList } from '@Redux/detail/Group/interfaces';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@Redux/detail/store';
import cN from 'classnames';
import styles from '../styles.module.scss';

interface I_Props {
    flights: I_FlightList[];
    isBack: boolean;
}

const FlightList: React.FC<I_Props> = ({ flights, isBack }) => {
    const timeToCH = (HrMin: string) => {
        const HrMinArray = HrMin.split(':');

        const hour = Number(HrMinArray[0]);
        const min = Number(HrMinArray[1]);

        return `${hour}小時${min}分鐘`;
    };

    const { curPage } = useSelector((state: RootState) => state.pageReducer);
    const isPrint = curPage === 'print';

    return (
        <ul className={styles[`flights__sub__list`]}>
            {flights.map((flight: I_FlightList, i: number) => (
                <li key={i} className={styles[`flights__sub__item`]}>
                    <div
                        className={cN(styles[`flights__sub__item__main`], [isPrint ? 'main' : ''])}
                    >
                        <div
                            className={cN(styles[`flights__sub__item__time-airport`], [
                                isPrint ? 'airport' : '',
                            ])}
                        >
                            <div
                                className={cN(styles[`flights__sub__item__time-airport__departs`], [
                                    isPrint ? 'airport_departs' : '',
                                ])}
                            >
                                <div>
                                    {`${flight.DepartureDate}`}
                                    <span>{`${flight.DepartTime}`}</span>
                                </div>
                                <div>{flight.DepartureAirport}</div>
                            </div>
                            <div
                                className={cN(styles[`flights__sub__item__time-airport__desns`], [
                                    isPrint ? 'airport_departs_desns' : '',
                                ])}
                            >
                                <div>
                                    {`${flight.ArriveDate}`}
                                    <span>{`${flight.ArriveTime}`}</span>
                                </div>
                                <div>{flight.ArriveAirport}</div>
                            </div>
                        </div>
                        <div
                            className={styles[`flights__sub__item__flight-no`]}
                        >{`${flight.Airline} ${flight.FlightNo}`}</div>
                    </div>
                    <div
                        className={cN(styles[`flights__sub__item__notes`], [
                            isPrint ? 'notes' : '',
                        ])}
                    >
                        <div
                            className={cN(styles[`flights__sub__item__time`], [
                                isPrint ? 'time' : '',
                            ])}
                        >{`飛行時間約${timeToCH(flight.FlightTime)}`}</div>
                        {isBack && i === flights.length - 1 && (
                            <div
                                className={cN(styles[`flights__sub__item__arrive`], [
                                    isPrint ? 'arrive' : '',
                                ])}
                            >{`抵達台灣日期${flight.ArriveDate}`}</div>
                        )}
                    </div>
                </li>
            ))}
        </ul>
    );
};

export default FlightList;
